import React, { useState ,useEffect} from 'react'
import { Col, Container, Row } from 'react-bootstrap'
import Sidebar from '../../Components/Sidebar'
import Header from '../../Components/Header'
import ReactDatatable from '@ashvin27/react-datatable';
import WalletDetail from '../../Modals/WalletDetail';
import { getUser } from '../../api/api'
import { getuserslist,deleteuser,getuserdaily,getusermonthly,getusercustom,getcsvdata, updateUserStatus, updateUserAllow, changeMaySent, deleteUsers } from '../../actions/users';
import { toastAlert } from '../../lib/toastAlert';
import moment from "moment";
import envConfig from "../../lib/config"
import { Link, useNavigate } from 'react-router-dom';
import Exportexcel from "../pdf/Excelexport"
import Exportpdf from "../pdf/Exportpdf"
import Exportcsv from "../pdf/Exportcsv"


function UsersList() {
  const navigate = useNavigate()
   // edit modal
   const [showView, setShowView] = useState(false);
   const [list, setList] = useState([])
   const [errors, setError] = useState()
   const [editData, setEditData] = useState({})
   const handleCloseView = () => setShowView(false);

   const [userdet1, setUser1] = useState([]);
   const [exportdata, setExportdata] = useState([])
   const [allcheck, setAllcheck] = useState(false);

   const [totalRecords, setTotalRecords] = useState(0);

   const handleChangemaysent = async (event) => {
    let { id, checked } = event.target;
    let handlemaychange = await updateUserStatus({ email: id, maySentChecked: checked });
    if (handlemaychange.Success) {
      toastAlert("success", 'Selected');
        getUserslist1()
    }
    else {
        toastAlert("error",'Error on Server');
    }
  }

  const getUserslist1 = async (skip = 0, limit = 5) => {
    var test = await getuserslist({skip, limit});
    console.log("testdata", {test, skip, limit});
    
    setUser1(test.userValue);
    setTotalRecords(test.totalRecords); 
    var ddd = test.userValue.map(({ _id, __v, id, ...rest }) => {

      return rest
    })
    setExportdata(ddd)
  };

  const AllowUsersss = async (id, deleted) => {
    var deleteddd = deleted == 0 ? 1 : 0
    let handlemaychange = await updateUserAllow({ email: id, maySentChecked: deleteddd });
    if (handlemaychange.Success) {
      if (deleteddd == 1) {
        toastAlert("success", "User Allowed")
      } else {
        toastAlert("error", "User NotAllowed")
      }
        getUserslist1()
    }
    else {
        toastAlert("error",'Error on Server');
    }
  }

  const TextEnlarge = (e) => {
    e.target.className = ""
    e.target.style.minWidth = "350px"
  }

  const TextReset = (e) => {
    e.target.className = "text-truncate"
  }
  const Enlarge = (e) => {
    if (e.target.naturalWidth > 700 || e.target.naturalHeight > 700) {
      e.target.width = String(Number(e.target.naturalWidth) / 4)
      e.target.height = String(Number(e.target.naturalHeight) / 4)
    }
    else {
      e.target.width = String(Number(e.target.naturalWidth) / 2)
      e.target.height = String(Number(e.target.naturalHeight) / 2)
    }
  }
  const Reset = (e) => {
    e.target.width = "25"
    e.target.height = "25"
  }

  const setMaySent = async (data) => {
    if (data?.target) {
      if (userdet1.length > 0) {

        var resp = await changeMaySent({ all: data.target.checked });
        if (resp?.Success) {
          setAllcheck(!allcheck)
          toastAlert("success", 'Success...Please wait for data refresh');
          getUserslist1()
        }
        else
          toastAlert("error",resp.msg)
      } else {
        toastAlert("error","Subscribers are not yet")
      }
    } else {
      var payload = {
        email: data.email,
        maySent: !data.maySent
      }

      var resp = await changeMaySent(payload);
      if (resp?.Success) {
        toastAlert("success",'Success...Please wait for data refresh');
        getUserslist1()
      }
      else
      toastAlert("error",resp.msg)
    }

  }

  const deleteUser = async () => {
    let handlemaychange = await deleteUsers();
    if (handlemaychange.Success) {
        toastAlert("success",'Deleted Succesfully');
        getUserslist1()
    }
    else {
        toastAlert("error", 'Error on Server');
    }
  }

  function editR(id) {
    navigate('/UserEdit', {state: id})
  }

  const state = {
    records: [
      {
        'sno': <p className='exchange_table_values text-center'>1</p>,
        "name": <p className='exchange_table_values text-center'>Demo</p>,
        "email": <p className='exchange_table_values text-center'>demo@gmail.com</p>,

      },
      {
        'sno': <p className='exchange_table_values text-center'>2</p>,
        "name": <p className='exchange_table_values text-center'>Demo</p>,
        "email": <p className='exchange_table_values text-center'>demo@gmail.com</p>,
      },
     
    ]
}
const columns = [
    {
      key: "action",
      text: "Action",
      className: "action",
      width: 100,
      align: "center",
      sortable: false,
      cell: record => {
        return (
          <div className='text-center exchange_table_values'>
            {record && <input type="checkbox" name={record._id} id={record.signemail} checked={record.MayChecked} onChange={(event) => { handleChangemaysent(event) }} />}
          </div>
        );
      }
    },
    {
      key: "ind",
      text: "SNO",
      className: "name",
      align: "center",
      sortable: false,
      cell: (row, index, column, id) => <p className='text-center exchange_table_values'>{index + 1}</p>,
    },
    {
      key: "name",
      text: "User Name",
      className: "name",
      align: "center",
      sortable: false,
      cell: (record) => <p className='text-center exchange_table_values'>{record.name}</p>,
    },
    {
      key: "curraddress",
      text: "User Address",
      className: "name",
      align: "center",
      sortable: false,
      cell: (record) => record?.curraddress?.map((item) => {
        return (
          <p className='text-center exchange_table_values'>{item}</p>
        )
      })
    },
    {
      key: "customurl",
      text: "Custom Url",
      className: "customurl",
      align: "center",
      sortable: false,
    },

    {
      key: "twitter",
      text: "Twitter",
      className: "twitter",
      align: "center",
      sortable: false,
    },

    {
      key: "Bio",
      text: "bio",
      className: "name",
      align: "center",
      sortable: false,
      cell: (rec) => (
        <div onMouseOver={(e) => TextEnlarge(e)} onMouseLeave={(e) => TextReset(e)}>
          <p className="text-truncate text-center exchange_table_values" Style="max-width: 350px;">{rec.bio}</p>
        </div>
      ),
    },

    {
      key: "image",
      text: "Profile Image Name",
      className: "image",
      align: "center",
      sortable: false,
      cell: (rec) => (
          <p className="text-truncate text-center exchange_table_values">{rec.image}</p>
      )
    },

    {
      key: "image",
      text: "Profile Image Preview",
      className: "image",
      align: "center",
      sortable: false,
      cell: (record) => (
        <div className='text-center exchange_table_values'>
          {record.image != "" && (
            <img
              onMouseOver={(e) => Enlarge(e)}
              onMouseLeave={(e) => Reset(e)}
              width="25"
              height="25"
              src={`${envConfig.Back_Url}/Users/${record.PrimaryAddr}/profileImg/${record.image}`}
            />
          )}
        </div>
      ),
    },
    {
      key: "coverimage",
      text: "Cover Image Name",
      className: "image",
      align: "center",
      sortable: false,
      cell: (record) => (
        <p className='text-center exchange_table_values'>{record.coverimage}</p>
    ),
    },

    {
      key: "coverimage",
      text: "Cover Image Preview",
      className: "image",
      align: "center",
      sortable: false,
      cell: (record) => (
        <div className='text-center exchange_table_values'>
          {console.log("asdeqweqw", record)}
          {record.coverimage != "" && (
            <img
              onMouseOver={(e) => Enlarge(e)}
              onMouseLeave={(e) => Reset(e)}
              width="25"
              height="25"
              src={`${envConfig.Back_Url}/Users/${record.PrimaryAddr}/coverImg/${record.coverimage}`}
            />
          )}
        </div>
      ),
    },

    {
      key: "date",
      text: "Date",
      className: "Date",
      align: "center",
      sortable: false,
      cell: (record) => (
        <div>
          <p className='text-center exchange_table_values'>{moment(record.date).format("MMMM,Do YYYY, hh:mm A")}</p>
        </div>
      ),
    },
    {
      key: "signemail",
      text: "User Mail",
      className: "Mail",
      align: "center",
      sortable: false,
      cell: (record) => (
          <p className='text-center exchange_table_values'>{record.signemail}</p>
      ),
    },
    {
      key: "deleted",
      text: "Retricted",
      className: "action",
      width: 100,
      align: "center",
      sortable: false,
      cell: record => {
        return (
          <>
            {record.deleted == 1 ? <p className="allow text-center exchange_table_values" onClick={() => { AllowUsersss(record.signemail, record.deleted) }}><i class="fa-solid fa-user-lock"></i></p> : <p className="notallow" onClick={() => { AllowUsersss(record.signemail, record.deleted) }}><i class="fa-solid fa-user-lock"></i></p>}
          </>
        );
      }
    },
    {
      key: "action",
      text: "Edit",
      className: "action",
      width: 100,
      align: "center",
      sortable: false,
      cell: record => {
        return (
          <div className='text-center exchange_table_values'>
            <button
              className="btn btn-warning btn-sm mr-1"
              onClick={() => editR(record)}
            >
              <i className="fa fa-edit"></i>
            </button>
          </div>
        );
      },
    }
  ];

const config = {
  page_size: 5,
  length_menu: [10, 20, 50],
  filename: "Users",
  no_data_text: "No user found!",

  language: {
    length_menu: "Show _MENU_ result per page",
    filter: "Filter in records...",
    info: "Showing _START_ to _END_ of _TOTAL_ records",
    pagination: {
      first: "First",
      previous: <> Previous </>,
      next: <>Next</>,
      last: "Last",
    },
  },
  show_length_menu: true,
  show_filter: true,
  show_pagination: true,
  show_info: true,
  defaultSortAsc: true,
  total_record: totalRecords
};


useEffect(() => {
    getUserslist1();
}, [])

const listUserdata = async () => {
    try {
        let resp = await getuserslist();
        if (resp.Success) {
            setList(resp.userValue)
        } else {
            if (resp.error) {
                setError(resp.error);
                toastAlert("error", resp.error);
            }
        }
    } catch (err) {
        console.log("listplan err", err);

    }
}

const handlePagination = async ({ page_number, page_size }) => {
  console.log("Pagination event trigger");
  
  const skip = (page_number - 1) * page_size;
  const limit = page_size;

  console.log("Pagination event:", { page_number, page_size, skip, limit }); 

  getUserslist1(skip, limit); 
};

  return (
    <>
    <Container fluid className='common_bg position-relative'>
    <div className='liner'></div>
    <Row>

    <Col xl={2} lg={0} className='p-0 d-none d-xl-block'>
        <Sidebar/>
    </Col>
    <Col xl={10} lg={12}>
        <Header title={'Users List'}/>
        <div className='common_page_scroller mt-5 pe-2'>
        <div className="page_header">
        <h2>User List</h2>


        <div className="selection_sec">
          <div className="checkbox_sec_user">
            <span>SELECT ALL</span>
            <input type="checkbox" className='selectall ms-2' checked={allcheck} onChange={(e) => setMaySent(e)} />
          </div>
          <div>
            <Link to="/UserAdd"><button className="ms-3" variant="contained" color="primary">Add Users</button></Link>
          </div>
          <div>
            <button className="ms-3" variant="contained" onClick={() => deleteUser()} color="primary">Delete Users</button>
          </div>
        </div>
      </div>
        <div className='exchange_table_holder dashboard_box rounded-3'>
          <ReactDatatable
              config={config}
              records={userdet1}
              columns={columns}
              onChange={(data) => handlePagination(data)}
              total_record={totalRecords}
              dynamic={true}
          />
        </div>
        <div className='bottom_btn_comp'>
        <Exportexcel excelData={exportdata} fileName={'users'} />
        <Exportpdf pdfData={exportdata} fileName={'users'} />
        <Exportcsv csvData={exportdata} fileName={'users'} />
      </div>
        </div>

    </Col>
    </Row>
    </Container>

    {/* modals */}
    <WalletDetail show={showView} handleClose={handleCloseView}  listUser={() => { listUserdata() }} editData={editData}/>
    {/* end of modals */}

    </>
  )
}

export default UsersList